import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('layawayProductsCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/layaways/types'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.layawayProducts,
    cacheName: 'layawayTypes'
  }));